export default "__VITE_ASSET__Cr5tPp$W__"